import { useTranslation } from 'react-i18next'
import {
  useAddUserDetailsMutation,
  useUpdateUserDetailsMutation,
} from '../../api/app/UserManagementApiService'
import { showToast } from '../../components/common/toast/Toast'
import { UserRoleState } from '../../interface/response/UserRolesResponse'

export const useAddUpdateUserHooks = (
  selectedData: UserRoleState,
  userId: string | undefined,
  onCloseModal: () => void,
) => {
  const [addNewUser] = useAddUserDetailsMutation()
  const [updateUserData] = useUpdateUserDetailsMutation()
  const { t } = useTranslation(['translation'])

  const displayErrorToast = (message: string, code: string) => {
    showToast(`${message}(${code})`, 'error')
  }

  const addUserDetails = () => {
    addNewUser({
      userName: selectedData.userInfo.userName,
      phone: selectedData.userInfo.phone,
      email: selectedData.userInfo.email,
      roles: selectedData.roles,
      customerCode: selectedData.customerCode ? selectedData.customerCode : '',
    })
      .unwrap()
      .then((response) => {
        if (response?.requestStatus) {
          showToast(t(`messages.${response?.code}`))
        } else {
          displayErrorToast(t(`messages.${response?.code}`), response?.code)
        }
      })
      .catch((error) =>
        displayErrorToast(t(`messages.${error?.status}`), error?.status),
      )
    onCloseModal?.()
  }

  const updateUserDetails = () => {
    if (!userId) {
      displayErrorToast('User ID is required', 'INVALID_USER_ID')
      return
    }
    updateUserData({
      userId: parseInt(userId),
      userName: selectedData.userInfo.userName,
      phone: selectedData.userInfo.phone,
      email: selectedData.userInfo.email,
      roles: selectedData.roles,
      customerCode: selectedData.customerCode ? selectedData.customerCode : '',
    })
      .unwrap()
      .then((response) => {
        if (response?.requestStatus) {
          showToast(t(`messages.${response?.code}`))
        } else {
          displayErrorToast(t(`messages.${response?.code}`), response?.code)
        }
      })
      .catch((error) =>
        displayErrorToast(t(`messages.${error?.status}`), error?.status),
      )
    onCloseModal?.()
  }

  return {
    addUserDetails,
    updateUserDetails,
  }
}
